import React, {useEffect} from "react"
import "./useObserverClassSetter.scss"

const supportsIntersectionObserver = () => {
  // React components in Gatsby must render successfully in the browser and in a node.js environment
  if (!window) {
    return false
  }
  return (
    "IntersectionObserver" in window &&
    "IntersectionObserverEntry" in window &&
    "intersectionRatio" in window.IntersectionObserverEntry.prototype
  )
}

export function useObserverClassSetter() {
  // const triggerEl = supportsIntersectionObserver() ? <div id="top-of-site-pixel-anchor" /> : null
  const triggerEl = <div id="top-of-site-pixel-anchor" />

  useEffect(() => {
    if (supportsIntersectionObserver()) {
      const el = document.querySelector("#top-of-site-pixel-anchor")
      if (!el) throw new Error("#top-of-site-pixel-anchor not found")
      const observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          // 					console.log("isIntersecting", true)
          document.body.classList.remove("header-not-at-top")
        } else {
          // 					console.log("isIntersecting", false)
          document.body.classList.add("header-not-at-top")
        }

        // boundingClientRect is a rect relative to viewport (x with y)
        // entries[0].boundingClientRect.y - is working unstable reporting -1 from time to time

        // const y = entries[0].boundingClientRect.y;
        // if (y < 0) {
        // 	document.body.classList.add("header-not-at-top");
        // } else {
        // 	document.body.classList.remove("header-not-at-top");
        // }
        // console.log("y", y);
      })
      observer.observe(el)
      return () => observer.unobserve(el)
    }
  }, [])

  return triggerEl
}
